import React, { useState} from 'react';
import Alert from './Alert';
function ShowAsset(props) {
    const[assetId,setAssetId]=useState("");
    const[assetName,setAssetName]=useState("");
    const[assetOwner,setAssetOwner]=useState("");
    const[assetGrade,setAssetGrade]=useState("");
    const[assetCondition,setAssetCondition]=useState("");
    const [assetManufacturingYear, setAssetManufacturingYear] = useState("");
    const [assetManufacturer, setAssetManufacturer] = useState("");
    const [assetSet, setAssetSet] = useState("");
    const [assetDetails,setAssetDetails]=useState("");
    const getAssetName=async (assetId)=>{
        try{
          const result = await props.SimpleContract.methods.getAssetName(assetId).call();
          setAssetName(result);
        }
        catch(err){
          console.log(err);
        }
    }
    const getAssetOwner=async (assetId)=>{
        try{
          const result = await props.SimpleContract.methods.getAssetOwner(assetId).call();
          setAssetOwner(result);
        }
        catch(err){
          console.log(err);
        }
    }
    const getAssetGrade=async (assetId)=>{
        try{
          let result = await props.SimpleContract.methods.getAssetGrade(assetId).call();
          result=parseFloat(result);
          result=result/10;
          setAssetGrade(result);
        }
        catch(err){
          console.log(err);
        }
    }
    const getAssetCondition=async (assetId)=>{
        try{
          const result = await props.SimpleContract.methods.getAssetCondition(assetId).call();
          setAssetCondition(result);
        }
        catch(err){
          console.log(err);
        }
    }
    const getAssetManufacturingYear=async (assetId)=>{
        try{
          const result = await props.SimpleContract.methods.getAssetManufacturingYear(assetId).call();
          setAssetManufacturingYear(result);
        }
        catch(err){
          console.log(err);
        }
    }
    const getAssetManufacturer=async (assetId)=>{
        try{
          const result = await props.SimpleContract.methods.getAssetManufacturer(assetId).call();
          setAssetManufacturer(result);
        }
        catch(err){
          console.log(err);
        }
    }
    const getAssetSet=async (assetId)=>{
        try{
          const result = await props.SimpleContract.methods.getAssetSet(assetId).call();
          setAssetSet(result);
        }
        catch(err){
          console.log(err);
        }
    }
    const getAssetDetails=async (assetId)=>{
      try{
        const result = await props.SimpleContract.methods.getAssetDetails(assetId).call();
        setAssetDetails(result);
      }
      catch(err){
        console.log(err);
      }
  }
    const setDetails=(e)=>{
        props.setProgress(10);
        e.preventDefault();
        getAssetName(assetId);
        getAssetOwner(assetId);
        getAssetGrade(assetId);
        getAssetCondition(assetId);
        getAssetManufacturingYear(assetId);
        getAssetManufacturer(assetId);
        getAssetSet(assetId);
        getAssetDetails(assetId);
        props.setProgress(100);
    }
    const handleInputs=(e)=>{
      let value=e.target.value;
      setAssetId(value);
    }
    const showDetails=()=>{
        if(assetName!==""){
            return(
                <>
                <div className="forcenter">
                <div className="forshowing">
                <div className="container mt-5 mb-5">
                <h1 style={{fontSize:"6vw"}} className="mb-4">Asset <span className="badge bg-primary"  >Info</span></h1>
                <table className="table mb-5">
                <tbody>
                    <tr>
                    <th>Asset Name</th>
                    <td>{assetName}</td>
                    </tr>
                    <tr>
                    <th>Asset Owner</th>
                    <td>{assetOwner}</td>
                    </tr>
                    <tr>
                    <th>Asset Grade</th>
                    <td>{assetGrade}</td>
                    </tr>
                    <tr>
                    <th>Asset Condition</th>
                    <td>{assetCondition}</td>
                    </tr>
                    <tr>
                    <th>Asset Manufacturing Year</th>
                    <td>{assetManufacturingYear}</td>
                    </tr>
                    <tr>
                    <th>Asset Manufacturer</th>
                    <td>{assetManufacturer}</td>
                    </tr>
                    <tr>
                    <th>Asset Set</th>
                    <td>{assetSet}</td>
                    </tr>
                    <tr>
                    <th>Asset Details</th>
                    <td>{assetDetails}</td>
                    </tr>
                </tbody>
                </table>
                </div>
                </div>
                </div>
                </>
            )
        }
    }
    const isMetaMaskInstall=()=>{
      if(props.SimpleContract===undefined){
          const  obj={
              type:"warning",
              message:"Please Install MetaMask and Refresh the Page"
          }
          return(
              <Alert alert={obj}/>
          )
      }
  }
    return (
        <>
        {isMetaMaskInstall()}
        <div className="forcenter">
        <div className="fordetail">
        <form className="container mt-4">
            <div className="form-floating mb-5">
                <input type="text" className="form-control" id="_assetId" name="_assetId" value={assetId}  placeholder="assetId" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Enter Asset Id</label>
            </div>
            <button type="submit" className="btn btn-primary" disabled={!(assetId!=="")} onClick={setDetails}>Show Details</button>
        </form> 
        </div>
        </div>
         {showDetails()}
        </>
    )
}

export default ShowAsset
